/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export var degreesToRadians = function degreesToRadians(degrees) {
  return degrees * Math.PI / 180;
};

export var radiansToDegrees = function radiansToDegrees(radians) {
  return 180 * radians / Math.PI;
};

export var midAngle = function midAngle(arc) {
  return arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
};

export var positionFromAngle = function positionFromAngle(angle, distance) {
  return {
    x: Math.cos(angle) * distance,
    y: Math.sin(angle) * distance
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/core/es/lib/polar/utils.js
// module id = 812
// module chunks = 0